export default {
  'apiConnectionGroup.title': 'Gestionar Grupo de Conexiones Api',

  'apiConnectionGroup.form.id': 'ID',
  'apiConnectionGroup.form.enable': 'Habilitado',
  'apiConnectionGroup.form.name': 'Nombre',
  'apiConnectionGroup.form.description': 'Descripción',

  'apiConnectionGroup.form.statusLabel': '¿Elemento Habilitado?',

  'apiConnectionGroup.enabled': 'Habilitado',
  'apiConnectionGroup.disabled': 'Deshabilitado',
  'apiConnectionGroup.apiConnection': 'Conexión Api',
};
